define([
    "skylark-utils/css"
], function(css) {
    return css;
});
